module.exports = __webpack_public_path__ + "static/media/family-build.9707acbb.svg";